<template>
  <div class="info-display-two">
    <div class="image-circle">
      <img :src="itemData.img">
    </div>
    <div class="info">
      <span>{{ itemData.region }} Africa<span class="highlighted">{{ itemData.name }}</span></span>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase'
export default {
  props: ['itemid'],
  firebase: function () {
    return {
      itemData: {
        source: db.ref('attributes/countries/' + this.itemid),
        asObject: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Country.vue?12e66f34